<script setup>
import { computed } from 'vue'
import { useRoute } from 'vue-router'
import Header from '@/components/common/Header.vue'
import Footer from '@/components/common/Footer.vue'

const route = useRoute()
const isPartyPage = computed(() => route.path === '/party')
</script>

<template>
  <div class="app" :class="{ 'party-theme': isPartyPage }">
    <Header />
    <router-view></router-view>
    <Footer />
  </div>
</template>

<style lang="scss">
@use '@/index.scss' as *;

.app {
  min-height: 100vh;
  display: flex;
  flex-direction: column;

  &.party-theme {
    @include page-theme('party');
  }
}

body {
  margin: 0;
}
</style>

<style>
:root {
  --header-height: 100px;
}

@media (max-width: 1024px) {
  :root {
    --header-height: 80px;
  }
}

@media (max-width: 768px) {
  :root {
    --header-height: 70px;
  }
}

@media (max-width: 480px) {
  :root {
    --header-height: 60px;
  }
}
</style>